import { getRefreshToken } from 'utils/token'

const API_URL = process.env.API_URL || ''

const refreshTokenMutation = (token: string) => {
  return JSON.stringify({
    variables: { token },
    query: `mutation RefreshToken($token: String!) {
      refreshToken(token: $token) {
        token, refreshToken
      }
    }`,
  })
}

const MAX_RETRIES = 2
const RETRY_DELAY = 1000

const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))

export const fetchNewTokens = async (
  retryCount = 0
): Promise<{
  token?: string
  refreshToken?: string
  error?: 'INVALID_REFRESH_TOKEN' | 'NETWORK_ERROR'
}> => {
  const t_r = getRefreshToken()

  try {
    const response = await fetch(API_URL, {
      method: 'POST',
      body: refreshTokenMutation(t_r),
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (response.status === 401 || response.status === 403) {
      return { error: 'INVALID_REFRESH_TOKEN' }
    }

    if (response.status >= 500) {
      if (retryCount < MAX_RETRIES) {
        await delay(RETRY_DELAY * (retryCount + 1))
        return fetchNewTokens(retryCount + 1)
      }
      return { error: 'NETWORK_ERROR' }
    }

    const result = await response.json()

    if (result?.errors) {
      const errorCode = result.errors[0]?.extensions?.code
      if (errorCode === 'INVALID_TOKEN' || errorCode === 'TOKEN_NOT_ACTIVE') {
        return { error: 'INVALID_REFRESH_TOKEN' }
      }
    }

    return result?.data?.refreshToken ?? {}
  } catch (e) {
    if (retryCount < MAX_RETRIES) {
      await delay(RETRY_DELAY * (retryCount + 1))
      return fetchNewTokens(retryCount + 1)
    }
    return { error: 'NETWORK_ERROR' }
  }
}
